import { Box, Checkbox, Chip, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Stack, Typography, useMediaQuery } from '@mui/material'
import { useFormik } from 'formik';
import { FunctionComponent, SetStateAction, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { IPostEmailCampaign } from '../../../../modules/survey/shared-services/email-campaign/email-campaign.model';
import DistributionListService from '../../../../shared/services/distribution-list/distribution-list.service';
import { IDistributionList } from '../../../../shared/services/distribution-list/distribution-list.model';
import { DialogSaveButtons } from '../../miscellaneous-components/dialog-save-buttons';
import { useIsReportPeriodLocked } from '../../../../hooks/use-is-report-period-locked';

export const EmissionsEmailCampaignRecipientsForm: FunctionComponent<{
  newSurvey: IPostEmailCampaign,
  isSubmitted: number,
  setIsSubmitted?: React.Dispatch<SetStateAction<any>>,
  setNewSurvey: React.Dispatch<SetStateAction<any>>,
  handleNext: (values: string[]) => void,
  getOneEmailCampaign?: React.Dispatch<SetStateAction<any>>,
  campaignId?: string;
  isEditPage?: boolean,
  isEditPageSubmitting?: boolean,
}> = ({
  newSurvey,
  setNewSurvey,
  isSubmitted,
  setIsSubmitted,
  handleNext,
  getOneEmailCampaign,
  campaignId,
  isEditPage,
  isEditPageSubmitting,
}) => {
    //Services
    const distributionListService = new DistributionListService()
    //Hooks
    const isReportPeriodLocked = useIsReportPeriodLocked()
    //State
    const [distributionLists, setDistributionLists] = useState<IDistributionList[]>()
    const [selectedListsId, setSelectedListsId] = useState<string[]>([])
    const [formRendered, setFormRendered] = useState<boolean>(false)

    useEffect(() => {
      if (formRendered) {
        if (formRendered && !isEditPage) {
          formik.submitForm();
        }
      }
      setFormRendered(true)
    }, [isSubmitted])


    useEffect(() => {
      distributionListService.getAll()
        .then(response => {
          setDistributionLists(response)
        })
        .catch(err => console.log(err))
    }, [])



    const employeeCommuteSchema = Yup.object().shape({
      distributionListId: Yup.array().of(Yup.string()).min(1, 'At least one distribution list must be selected').required()
    })

    const formik = useFormik({
      initialValues: {
        distributionListId: newSurvey.distributionListId,
      },
      validationSchema: employeeCommuteSchema,
      onSubmit: (values) => {
        if (!isEditPage) {
          setNewSurvey((prevSurvey: IPostEmailCampaign) => ({ ...prevSurvey, distributionListId: values.distributionListId }))
          handleNext(values.distributionListId);
        }
        if (isEditPage && values.distributionListId.length > 0) {
          handleNext(values.distributionListId);
        }
      }
    });

    useEffect(() => {
      setSelectedListsId(newSurvey.distributionListId)
    }, [])

    const selectListHandler = (e: SelectChangeEvent<string[]>) => {
      const { value } = e.target;
      setSelectedListsId(typeof value === 'string' ? value.split(',') : value,);
      formik.setFieldValue('distributionListId', value)
    }

    const cancelHandler = () => {
      setSelectedListsId([])
      formik.resetForm();
    }

    return (
      <>
        {distributionLists && <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
          <InputLabel htmlFor='distributionListId'>Distribution List</InputLabel>
          <Select id='distributionListId' name='distributionListId' label='Distribution List'
            value={selectedListsId}
            onChange={selectListHandler}
            multiple
            disabled={isReportPeriodLocked === true}
            error={formik.touched.distributionListId && Boolean(formik.errors.distributionListId)}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value, index) => {
                  const selectedName = distributionLists.find(list => list.id === value)?.listName
                  return (
                    <Chip key={index} label={selectedName} />
                  )
                })}
              </Box>
            )}
            input={<OutlinedInput label="Distribution List" />}
          >
            {distributionLists.sort((a, b) => a.listName.localeCompare(b.listName)).map((list, index) => (
              <MenuItem key={index} value={list.id}>
                <Checkbox checked={selectedListsId?.includes(list.id)} />
                <ListItemText primary={list.listName} />
              </MenuItem>
            ))}
          </Select>
          {formik.touched.distributionListId && formik.errors.distributionListId &&
            <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{formik.errors.distributionListId}</FormHelperText>
          }
        </FormControl>}
        {isEditPage && setIsSubmitted &&
          <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-end' sx={{ mt: 3 }}>
            <DialogSaveButtons
              isForm={true}
              isSubmitting={isEditPageSubmitting}
              cancelHandler={cancelHandler}
              submitHandler={formik.submitForm}
              disableSaveButton={isReportPeriodLocked === true}
              disableCancelButton={isReportPeriodLocked === true}
            />
          </Stack>
        }
      </>
    )
  }